import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { EnvironmentService, HttpService, StorageService } from './core/services';

export interface TokenResponse {
  access_token : string;
  id_token: string;
}

@Injectable()
export class IdentityService {
    private url : string;
    private clientId : string;
    private redirectUri : string;
    private clientSecret : string;
  router: any;
  private headers: any;

    constructor(
        public httpService: HttpService,
        public envService: EnvironmentService,
        public storageService : StorageService,
        private http: Http,

      ) {
        this.url = this.envService.get('tokenUrl');
        this.clientId = this.envService.getStore('consumerKey');
        this.clientSecret = this.envService.getStore('clientSecret');
        this.headers = new Headers();
        this.headers.set('Content-Type', 'application/x-www-form-urlencoded');
        this.headers.set('Authorization', 'Basic ' +  btoa(this.clientId +':'+ this.clientSecret))
    
        this.redirectUri = this.envService.getStore('callbackUrl');
      }
    public getAccessTokenFromCode(code: string): Observable<Response> {
        const url = this.url
        console.log(url);
        console.log(this.clientId , this.clientSecret);
      let body = `grant_type=authorization_code&code=${code}&redirect_uri=${this.redirectUri}&client_id=${this.clientId}`;

      const options = {
        headers: this.headers,
        method: 'POST',
        body: body
      };
       


     return  this.http.request(url, options);
      

    // return back the response
      }}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/identity.service.ts